import styled from "styled-components";

export const FocusedBox = styled.div`
  max-width: ${({ maxWidth }) => (maxWidth ? `fit-content` : "100%")};
  border: 2px solid ${({ theme, focused }) => (focused ? theme.colors.blue["400"] : "transparent")};
  border-radius: ${({ theme }) => (theme.borderRadius.sm)};
  
  :focus {
    outline: none;
  }

  @media screen and (max-width: 675px) {
    max-width: 100%;
    width: 100%;
  }
`;

export const Link = styled.a`
  width: ${({ linkWidth }) => (linkWidth ? `${linkWidth}` : "100%")};
  border-radius: ${({theme}) => (theme.borderRadius.sm)};

  .secondary {
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.secondary.health_green};
    border: 2px solid ${({ theme }) => theme.colors.secondary.health_green};

    &:hover {
      background-color: ${({ theme }) => theme.colors.green["100"]};
    }
  }

  :focus {
    outline: none;
  }
`;

export const ButtonContainer = styled.button`
  background-color: ${({ isVariant, theme }) => (isVariant ? theme.colors.background : theme.colors.secondary.health_green)};
  color: ${({ isVariant, theme }) => (isVariant ? theme.colors.secondary.health_green : theme.colors.background)};
  font-size: 1.125rem;
  font-weight: ${({ theme }) => theme.fontWeight.fontWeight.fontWeightBold};
  padding: 0.625rem 2rem;
  height: 3rem;
  width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}rem` : "100%")};
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}rem` : "inherit")};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s linear;
  box-shadow: ${({ shadowy }) => (shadowy ? "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 5px 10px rgba(0, 0, 0, 0.3)" : "none")};
  border: 2px solid ${({ isVariant, theme }) => (isVariant ? theme.colors.secondary.health_green : "none")};

  &:hover {
    background-color: ${({ isVariant, theme }) => (isVariant ? theme.colors.green["100"] : theme.colors.green["700"])};
  }

  &.outlined {
    background: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.secondary.txt_green};
    border: 2px solid ${({ theme }) => theme.colors.secondary.health_green};
  }

  &.outlined:hover:not(.disabled) {
    background: ${({ theme }) => theme.colors.green[100]};
  }

  &.sensitive {
    background: ${({ theme }) => theme.palette.alert.dark};
  }

  &.danger {
    background: ${({ theme }) => theme.colors.error.main};
  }

  &.sensitive:hover:not(.disabled) {
    background: ${({ theme }) => theme.palette.error.main};
  }

  &.disabled {
    color: ${({ theme }) => theme.colors.gray.dark};
    background-color: ${({ theme }) => theme.colors.gray.disable};
    cursor: not-allowed;
  }

  :focus {
    outline: none;
  }

 

  @media screen and (max-width: 445px) {
    width: 100%;
    font-size: 1.125rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
